/**
 * @file 外部決済時フォーム自動送信
 *
 */
'use strict';

/**
 * @classname FormAutoSubmit
 * @classdesc 外部決済時フォーム自動送信
 */
export default class FormAutoSubmit {
	/**
	 * @constructor
	 * @param {jQuery} $e - .form-auto-submit
	 */
	constructor($e, controller) {
		console.log('CheckAgree.constructor');
		this._$e = $e;
        this._controller = controller;
        this.autoSubmit();
	};


	/**
	 * フォーム自動送信
	 *
	 * @memberof FormAutoSubmit
	 * @return {undefined}
	 */
	autoSubmit() {
		console.log('FormAutoSubmit.autoSubmit');
		const $formBtn = this._$e.find('[type=submit][data-form]');
        $formBtn.trigger('click');
	};
}
